import { Injectable } from '@angular/core';
import { CompanyStore } from './company.store';
import { Company } from './models/company.model';
import { tap, mapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { of, Observable } from 'rxjs';
import { CompanyQuery } from './company.query';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  constructor(private companyStore: CompanyStore, private companyQuery: CompanyQuery, private api: ApiService) {}

  /** Fetches all the companies and puts them in the company store. */
  fetchAllCompanies() {
    this.companyStore.setLoading(true);

    const request$: Observable<null> = this.api.get<Company>('companies').pipe(
      tap((companies) => {
        this.companyStore.upsertMany(companies);
      }),
      mapTo(null)
    );

    return this.companyQuery.getHasCache() ? of(null) : request$;
  }

  /** Fetch a specific company and puts it in the store */
  fetchCompany(companyId: number) {
    this.companyStore.setLoading(true);

    const request$: Observable<null> = this.api.getAnySingle<Company>('companies/' + companyId).pipe(
      tap((company) => this.companyStore.upsert(companyId, company)),
      mapTo(null)
    );

    return request$;
  }
}
